import { useState, useEffect } from "react";
import { SbEditableBlok } from "@storyblok/storyblok-editable";
import { useCommonContext } from "../../context/CommonDataContext";
import { extractResource } from "../../helper/extractResource";

interface TncConcentPropInterface {
  resourceData: SbEditableBlok;
}

function TncConcent({ resourceData }: TncConcentPropInterface) {
  const { links } = useCommonContext();
  const data = extractResource(resourceData, "signUpTermsAndCondition");
  const tncData = data?.[0];
  const [ppLink, setPpLink] = useState("/");
  const [tncLink, setTncLink] = useState("/");

  useEffect(() => {
    if (typeof links !== "undefined") {
      setPpLink(links[tncData?.privacy_policy_link?.id]?.real_path);
      setTncLink(links[tncData?.TnC_link?.id]?.real_path);
    }
  }, [links]);

  const ppReplace = `<a target="_blank" className="text-primary dark:bg-gray-100 dark:underline hover:underline" href=${ppLink}>${tncData?.privacy_policy_text}</a>`;
  const tncReplace = `<a target="_blank" className="text-primary dark:bg-gray-100 dark:underline hover:underline" href=${tncLink}>${tncData?.tncText}</a>`;

  let textBody = tncData?.bodyText?.replace("{privacy_policy_text}", ppReplace);
  textBody = textBody?.replace("{tnc_text}", tncReplace);

  return (
    <div className="w-80 pt-2 text-center flex flex-col justify-between" style={{ fontSize: "11px" }}>
      <div
        dangerouslySetInnerHTML={{
          __html: textBody
        }}
      />
    </div>
  );
}

export default TncConcent;
